<template>
    <CardPage :section="7" :page="8">
        <p>
            What advice and encouragement would you give to other young trans folks to assert their right to health care? Write up that advice in a 280
            character Tweet or Facebook post.
        </p>
        <v-textarea outline :rows="4" counter="280" maxlength="280" auto-grow v-model="socialPost"></v-textarea>
        <p>
            If you want, we encourage you to post that advice on your fav social media account!
        </p>
    </CardPage>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
    computed: {
        socialPost: sync('section7/socialPost')
    }
};
</script>
